var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPessoa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.688,
    height: 20.002,
    viewBox: "0 0 16.688 20.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.849,9.635a4.661,4.661,0,0,0,3.406-1.411,4.661,4.661,0,0,0,1.411-3.406,4.662,4.662,0,0,0-1.411-3.406,4.816,4.816,0,0,0-6.812,0,4.662,4.662,0,0,0-1.411,3.406,4.661,4.661,0,0,0,1.412,3.406A4.662,4.662,0,0,0,91.849,9.635Zm0,0",
    transform: "translate(-83.631)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.647,253.035a11.9,11.9,0,0,0-.162-1.264,9.958,9.958,0,0,0-.311-1.271,6.276,6.276,0,0,0-.522-1.185,4.472,4.472,0,0,0-.788-1.027,3.472,3.472,0,0,0-1.132-.711,3.91,3.91,0,0,0-1.445-.261,1.466,1.466,0,0,0-.783.332c-.235.153-.509.33-.816.526a4.674,4.674,0,0,1-1.055.465,4.1,4.1,0,0,1-2.582,0A4.663,4.663,0,0,1,6,248.175c-.3-.194-.578-.371-.816-.526a1.464,1.464,0,0,0-.783-.332,3.906,3.906,0,0,0-1.444.262,3.47,3.47,0,0,0-1.132.711,4.471,4.471,0,0,0-.787,1.026A6.288,6.288,0,0,0,.513,250.5,9.98,9.98,0,0,0,.2,251.771a11.855,11.855,0,0,0-.162,1.264c-.027.383-.04.78-.04,1.181a3.321,3.321,0,0,0,.986,2.513,3.551,3.551,0,0,0,2.542.927h9.631a3.55,3.55,0,0,0,2.542-.927,3.32,3.32,0,0,0,.987-2.513C16.687,253.814,16.674,253.416,16.647,253.035Zm0,0",
    transform: "translate(0 -237.654)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPessoa);
export default __webpack_public_path__ + "static/media/ico-pessoa.df41164aba593cbdedff4a0d383f95a2.svg";
export { ForwardRef as ReactComponent };